// Tiny shared CSV helper that takes an array of row objects (first row's
// keys become the header) and triggers a browser download. Mirrors the
// local helper in KeywordPlanner.jsx — extracted so other components can
// reuse the same format without duplicating logic.
import { toast } from "sonner";

export const csvDownload = (filename, rows) => {
    if (!rows || !rows.length) {
        toast.error("Nothing to export");
        return;
    }
    const cols = Object.keys(rows[0]);
    const escape = (v) => {
        const s = v == null ? "" : String(v);
        return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };
    const lines = [cols.join(",")].concat(
        rows.map((r) => cols.map((c) => escape(r[c])).join(","))
    );
    const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};
